/* tslint:disable */
/* eslint-disable */
/**
 * Mild Blue s.r.o. - Online Connect
 * Application allowing people to ask for admition in IKEM.
 *
 * The version of the OpenAPI document: development
 * Contact: support@mild.blue
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ClearUploadsDtoIn } from '../model';
// @ts-ignore
import { ClearUploadsDtoOut } from '../model';
// @ts-ignore
import { IdResponse } from '../model';
/**
 * UploadApi - axios parameter creator
 * @export
 */
export const UploadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Removes uploads that are uploaded to no submission and are older than specified number of seconds.
         * @param {ClearUploadsDtoIn} [clearUploadsDtoIn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSubmissionsFileClearPost: async (clearUploadsDtoIn?: ClearUploadsDtoIn, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/submissions/file/clear`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication apiKey required
            await setApiKeyToObject(localVarHeaderParameter, "X-Api-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clearUploadsDtoIn, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload a file and get its id.
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSubmissionsFilePost: async (file: any, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('apiSubmissionsFilePost', 'file', file)
            const localVarPath = `/api/submissions/file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication sessionAuth required


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UploadApi - functional programming interface
 * @export
 */
export const UploadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UploadApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Removes uploads that are uploaded to no submission and are older than specified number of seconds.
         * @param {ClearUploadsDtoIn} [clearUploadsDtoIn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSubmissionsFileClearPost(clearUploadsDtoIn?: ClearUploadsDtoIn, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClearUploadsDtoOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSubmissionsFileClearPost(clearUploadsDtoIn, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Upload a file and get its id.
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSubmissionsFilePost(file: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSubmissionsFilePost(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UploadApi - factory interface
 * @export
 */
export const UploadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UploadApiFp(configuration)
    return {
        /**
         * 
         * @summary Removes uploads that are uploaded to no submission and are older than specified number of seconds.
         * @param {ClearUploadsDtoIn} [clearUploadsDtoIn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSubmissionsFileClearPost(clearUploadsDtoIn?: ClearUploadsDtoIn, options?: any): AxiosPromise<ClearUploadsDtoOut> {
            return localVarFp.apiSubmissionsFileClearPost(clearUploadsDtoIn, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload a file and get its id.
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSubmissionsFilePost(file: any, options?: any): AxiosPromise<IdResponse> {
            return localVarFp.apiSubmissionsFilePost(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UploadApi - object-oriented interface
 * @export
 * @class UploadApi
 * @extends {BaseAPI}
 */
export class UploadApi extends BaseAPI {
    /**
     * 
     * @summary Removes uploads that are uploaded to no submission and are older than specified number of seconds.
     * @param {ClearUploadsDtoIn} [clearUploadsDtoIn] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadApi
     */
    public apiSubmissionsFileClearPost(clearUploadsDtoIn?: ClearUploadsDtoIn, options?: any) {
        return UploadApiFp(this.configuration).apiSubmissionsFileClearPost(clearUploadsDtoIn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload a file and get its id.
     * @param {any} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadApi
     */
    public apiSubmissionsFilePost(file: any, options?: any) {
        return UploadApiFp(this.configuration).apiSubmissionsFilePost(file, options).then((request) => request(this.axios, this.basePath));
    }
}
